import React from 'react';
import AddCriteria from 'components/FeedbackCriteria/AddCriteria';
import FeedbackCriteria from 'components/FeedbackCriteria/FeedbackCriteria';
import { useFeatureFlags } from 'components/shared/hooks';

const FeedbackCriteriaWrapper = ({
  handleCriteriaUpdate,
  options,
  handleUpdate,
  applyChanges,
  content,
}) => {
  const canUseCustomFeedbackCriteria = useFeatureFlags([
    'custom_feedback_criteria',
  ]);

  const addFeedbackCriteria = updates => {
    handleCriteriaUpdate(updates);
    const newOptions = { ...options, gradable: true };
    handleUpdate({ gradable: true });
    applyChanges({ options: newOptions });
  };

  const selectedCriteria = content.criteria;

  return (
    <>
      {selectedCriteria && selectedCriteria.length > 0 ? (
        <FeedbackCriteria
          selectedCriteria={selectedCriteria}
          handleUpdate={handleCriteriaUpdate}
          canUseCustomFeedbackCriteria={canUseCustomFeedbackCriteria}
        />
      ) : (
        <div>
          <AddCriteria
            handleUpdate={addFeedbackCriteria}
            canUseCustomFeedbackCriteria={canUseCustomFeedbackCriteria}
          />
        </div>
      )}
    </>
  );
};

export default FeedbackCriteriaWrapper;
